module.exports = __webpack_public_path__ + "img/APUA_1000X460.d39d5ff5.jpg";